import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { DevSupport } from "@react-buddy/ide-toolbox";
import { ComponentPreviews, useInitial } from "./dev";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../src/components/theme"; // Adjust the path to where your theme is located

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <ThemeProvider theme={theme}>
      <DevSupport ComponentPreviews={ComponentPreviews} useInitialHook={useInitial}>
        <App />
      </DevSupport>
    </ThemeProvider>
  </React.Fragment>
);
